import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

import {
  Button,
  List,
  ListItem,
  Stack,
  useTheme,
  Typography,
  Box,
} from "@mui/material";
import { INavbarMenu } from "@/@types/NavbarMenuList";
export const navbarMenuList: INavbarMenu[] = [
  {
    label: "Home",
    href: "/",
  },
  {
    label: "Trade",
    href: "/trade",
  },
  {
    label: "Sign in",
    href: "/sign-in",
  },
  {
    label: "Sign up",
    href: "/sign-up",
  },
  {
    label: "Manual",
    href: "https://hap-public.obs.ap-southeast-2.myhuaweicloud.com/P2P%20manual%282%29.pdf",
  },
];

const UnauthorizedNavbarMenu = () => {
  const theme = useTheme();
  const location = useLocation();
  const navigate = useNavigate();
  return (
    <List sx={{ display: "flex", padding: 0, margin: 0, listStyle: "none" }}>
      {navbarMenuList.map((item) => (
        <ListItem
          key={item.href}
          sx={{
            my: "0",
            p: "0",
          }}
        >
          <Box
            position="relative"
            mx="27px"
            sx={{
              "&:hover": {
                ".dropdown-toggle": {
                  display: "block !important",
                },
              },
            }}
          >
            <Typography
              onClick={() => {
                if (item.label === "Manual") {
                  window.open(item.href, "_blank");
                  return;
                }
                navigate(item.href);
              }}
              variant="navBarText"
              sx={{
                color:
                  item.href === location.pathname
                    ? theme.colors.blueDark
                    : undefined,
                fontWeight: item.href === location.pathname ? "700" : undefined,
                "&:hover": {
                  cursor: "pointer",
                  color: theme.colors.blueDark,
                  fontWeight: "700",
                },
              }}
            >
              {item.label}
            </Typography>

            {item.sub && (
              <Stack
                bottom="0"
                left="50%"
                className="dropdown-toggle"
                direction="column"
                position="absolute"
                display="none"
                bgcolor={theme.colors.white}
                sx={{
                  transform: "translate(-50%,100%)",
                }}
              >
                {item.sub.map((subItem) => (
                  <Button
                    key={subItem.href}
                    onClick={() => {
                      navigate(subItem.href);
                    }}
                    sx={{
                      width: "100%",
                      px: "1rem",
                      py: "0.7rem",
                      whiteSpace: "nowrap",
                      borderRadius: "0",
                      color:
                        subItem.href === location.pathname
                          ? theme.colors.navbarBGColor
                          : theme.colors.black,
                      backgroundColor:
                        subItem.href === location.pathname
                          ? theme.colors.black
                          : theme.colors.navbarBGColor,
                      "&:hover": {
                        color: theme.colors.lightFontColor,
                        bgcolor: theme.colors.black,
                      },
                    }}
                  >
                    {subItem.label}
                  </Button>
                ))}
              </Stack>
            )}
          </Box>
        </ListItem>
      ))}
    </List>
  );
};

export default UnauthorizedNavbarMenu;
